<template>
  <article class="edifice">
    <div class="container container-small">
      <div
        class="edifice-wrapper"
        :class="{
          'active-item-1': activeItem === 1,
          'active-item-2': activeItem === 2,
          'active-item-3': activeItem === 3,
          'active-item-4': activeItem === 4
        }"
      >
        <section
          v-for="(section, index) in edifice" :key="index"
          :style="{'z-index': 100 - index}"
          :class="{
            active: index == activeItem
          }"
        >
          <span
            class="pointer"
            v-if="section.header"
            @click="setActive(index)"
          >
            <svg class="arrow-big">
              <use class="default" xlink:href="#tringleDarkSvg"></use>
              <use class="on-active" xlink:href="#tringleAccentSvg"></use>
              <use class="on-active use-contrast" xlink:href="#tringleContrastSvg"></use>
              <use class="default use-contrast" xlink:href="#tringleSvg"></use>
            </svg>
          </span>
          <img v-if="section.image" :src="section.image" :alt="section.header">
        </section>
      </div>
      <div class="descriptions">
        <div
          class="description"
          v-for="(section, index) in edifice" :key="index"
          :class="{
            active: index == activeItem
          }"
        >
          <h3 class="text-xl" v-accent="section.header"></h3>
          <p class="text-m" v-accent="section.description"></p>
          <ul class="text-m">
            <li v-for="(item, itemIndex) in section.list" :key="itemIndex">
              <svg>
                <use xlink:href="#tringleDarkSvg"></use>
                <use class="use-contrast" xlink:href="#tringleSvg"></use>
              </svg>
              <span v-accent="item"></span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </article>
</template>

<script>

export default {
  name: 'edificeSection',
  props: ['edifice'],
  data () {
    return {
      activeItem: 1
    }
  },
  methods: {
    setActive (index) {
      this.activeItem = index
    }
  }
}
</script>

<style scoped lang="scss">
  .arrow-big {
    .on-active {
      display: none;
    }
  }
  .edifice {
    display: block;
    padding: 45px 0;
    justify-content: space-between;
    // min-height: 100vh;
    position: relative;
    .container {
      height: 100%;
    }
  }
  .edifice-wrapper {
    position: relative;
    width: 60vw;
    max-width: 390px;
    margin: 0 auto;
    height: 56px;
    max-height: 60vh;
    margin-bottom: 70vw;
    @include mobile-small {
      width: 50vw;
    }
  }
  .pointer {
    display: block;
    text-align: left;
    position: absolute;
    top: 10%;
    left: -9px;
    width: 48px;
    height: 48px;
    transform: translateX(-100%);
    transition: $transition;
    background-color: transparent;
    transform-origin: center center;
    @include mobile-small {
      left: -10px;
    }
    .arrow-big {
      position: absolute;
      top: 0;
      right: 0;
      width: 48px;
      height: 48px;
    }
  }

  section {
    transition: all 0.5s ease-in-out;
    &:nth-child(1) {
      transform: translate(-50%, 0);
    }
    &:nth-child(2) {
      transform: translate(-50%, 0);
      margin-top: 2px;
      .active-item-1 & {
        transform: translate(-50%, 52%);
      }
    }
    &:nth-child(3) {
      transform: translate(-50%, 0);
      .active-item-1 &,
      .active-item-2 & {
        transform: translate(-50%, 52%);
      }
    }
    &:nth-child(4) {
      transform: translate(-50%, 0);
      .active-item-1 &,
      .active-item-2 &,
      .active-item-3 & {
        transform: translate(-50%, 52%);
      }
    }
    &:nth-child(5) {
      transform: translate(-50%, 0);
      .active-item-1 &,
      .active-item-2 &,
      .active-item-3 &,
      .active-item-4 & {
        transform: translate(-50%, 52%);
      }
    }
  }

  section {
    text-align: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    min-height: 50px;
    height: 190px;
    &.active {
      // img {
      //   opacity: 1 !important;
      // }
      .pointer {
        animation-name: heartbeat;
        animation-timing-function: ease-in-out;
        animation-iteration-count: infinite;
        animation-duration: 2s;
      }
      .arrow-big {
        .default {
          display: none;
        }
        .on-active {
          display: block;
        }
      }
      &:nth-child(2n) {
        .pointer {
          animation-name: heartbeat2;
        }
      }
    }
    &:nth-child(1) {
      top: 0;
      .pointer {
        top: 20%;
        @include mobile-small {
          top: 5%;
        }
      }
      // &:hover {
      //   img {
      //     opacity: 0;
      //   }
      // }
    }
    &:nth-child(2) {
      top: 25%;
      img {
        width: 84%;
        // opacity: 0;
      }
    }
    &:nth-child(3) {
      top: 50%;
      img {
        width: 84%;
        // opacity: 0;
      }
      .pointer {
        top: 35%;
        @include mobile-small {
          top: 10%;
        }
      }
    }
    &:nth-child(4) {
      top: 75%;
      img {
        width: 84%;
        // opacity: 0;
      }
      .pointer {
        top: 40%;
        @include mobile-small {
          top: 14%;
        }
      }
    }
    &:nth-child(5) {
      top: 100%;
      img {
        width: 110%;
        margin-left: -5%;
      }
      .pointer {
        top: 50%;
        @include mobile-small {
          top: 20%;
        }
      }
    }
    &:nth-child(2n) {
      .pointer {
        left: auto;
        right: -9px;
        transform: translateX(100%);
        @include mobile-small {
          right: -10px;
        }
        .arrow-big {
          right: auto;
          left: 0;
          top: -9px;
          transform: rotate(180deg);
          transform-origin: center center;
        }
      }
    }
    img {
      width: 100%;
      display: block;
      margin: 0 auto;
      transition: $transition;
    }
  }
  .description {
    display: none;
    &.active {
      display: block;
    }
    h3 {
      color: $text-accent;
    }
    p, ul {
      transition: $transition;
      margin: 0;
      font-weight: 500;
    }
    ul {
      list-style: none;
      padding: 0;
      li {
        margin: 4px 30px;
        position: relative;
        svg {
          width: 14px;
          height: 14px;
          position: absolute;
          top: 6px;
          left: -30px;
        }
      }
    }
  }
@keyframes heartbeat
{
  0%
  {
    transform: translateX(-100%) scale(1);
  }
  50%
  {
    transform: translateX(-100%) scale(1.1);
  }
  100%
  {
    transform: translateX(-100%) scale(1);
  }
}
@keyframes heartbeat2
{
  0%
  {
    transform: translateX(100%) scale(1);
  }
  50%
  {
    transform: translateX(100%) scale(1.1);
  }
  100%
  {
    transform: translateX(100%) scale(1);
  }
}
</style>
